module.exports = __webpack_public_path__ + "img/wximg14.e2ddd091.png";